import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionMaterialEventsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionMaterialEventDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionMaterialEventDocumentSortInput> | Types.ProductionMaterialEventDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionMaterialEventsQuery = { __typename?: 'Query', productionMaterialEvents?: { __typename?: 'ProductionMaterialEventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionMaterialEventDocument', id: string, name: string, productionMaterialEventId: string, status: Types.ProductionMaterialEventStatus, tenantId: string, createdBy: string, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMaterialEventGroupsQueryVariables = Types.Exact<{
  groupBy: Types.MaterialEventGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMaterialEventGroupsQuery = { __typename?: 'Query', materialEventGroups: Array<{ __typename?: 'MaterialEventGroupBucket', key: string, label: string, count: number }> };

export type GetSpaceEventGroupsQueryVariables = Types.Exact<{
  groupBy: Types.SpaceEventGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSpaceEventGroupsQuery = { __typename?: 'Query', spaceEventGroups: Array<{ __typename?: 'SpaceEventGroupBucket', key: string, label: string, count: number }> };

export type GetTaskEventGroupsQueryVariables = Types.Exact<{
  groupBy: Types.TaskEventGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetTaskEventGroupsQuery = { __typename?: 'Query', taskEventGroups: Array<{ __typename?: 'TaskEventGroupBucket', key: string, label: string, count: number }> };

export type GetProductionMaterialEventQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetProductionMaterialEventQuery = { __typename?: 'Query', productionMaterialEvent?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null };

export type GetProductionMaterialEventDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionMaterialEventDetailsQuery = { __typename?: 'Query', productionMaterialEventDetails?: { __typename?: 'ProductionMaterialEventDetailsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionMaterialEventDetailDocument', id: string, productionMaterialEventDetailId: string, productionMaterialEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, materialItemId: string, materialItemDescription: string, materialName: string, materialErpCode: string, multiple: number, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionMaterialEventDetailsByEventsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionMaterialEventDetailDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionMaterialEventDetailDocumentSortInput> | Types.ProductionMaterialEventDetailDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionMaterialEventDetailsByEventsQuery = { __typename?: 'Query', productionMaterialEventDetails?: { __typename?: 'ProductionMaterialEventDetailsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionMaterialEventDetailDocument', id: string, productionMaterialEventDetailId: string, productionMaterialEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, materialItemId: string, materialItemDescription: string, materialName: string, materialErpCode: string, multiple: number, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionTaskEventsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionTaskEventDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionTaskEventDocumentSortInput> | Types.ProductionTaskEventDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionTaskEventsQuery = { __typename?: 'Query', productionTaskEvents?: { __typename?: 'ProductionTaskEventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionTaskEventDocument', id: string, tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTaskEventCostsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionTaskEventDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetTaskEventCostsQuery = { __typename?: 'Query', productionTaskEvents?: { __typename?: 'ProductionTaskEventsConnection', nodes?: Array<{ __typename?: 'ProductionTaskEventDocument', id: string, productionTaskEventId: string, costPerEvent?: number | null, costEffectiveFrom?: Types.TDateISO | null, costEffectiveTo?: Types.TDateISO | null }> | null } | null };

export type GetProductionTaskEventQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetProductionTaskEventQuery = { __typename?: 'Query', productionTaskEvent?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null }> } | null };

export type GetProductionTaskEventDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionTaskEventDetailsQuery = { __typename?: 'Query', productionTaskEventDetails?: { __typename?: 'ProductionTaskEventDetailsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionTaskEventDetailDocument', id: string, productionTaskEventDetailId: string, productionTaskEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, multiple: number, sequence: number, materialItemId?: string | null, materialItemDescription?: string | null, taskEventTypeId: string, taskEventTypeName: string, unitsPerHour?: number | null, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionSpaceEventsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionSpaceEventDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionSpaceEventDocumentSortInput> | Types.ProductionSpaceEventDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionSpaceEventsQuery = { __typename?: 'Query', productionSpaceEvents?: { __typename?: 'ProductionSpaceEventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceEventDocument', id: string, tenantId: string, productionSpaceEventId: string, name: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionSpaceEventStatus, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionSpaceEventQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetProductionSpaceEventQuery = { __typename?: 'Query', productionSpaceEvent?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null };

export type GetProductionSpaceEventDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionSpaceEventDetailsQuery = { __typename?: 'Query', productionSpaceEventDetails?: { __typename?: 'ProductionSpaceEventDetailsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceEventDetailDocument', id: string, productionSpaceEventDetailId: string, productionSpaceEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, productionSpaceCategoryId: string, categoryCode: string, productionSpaceTypeId: string, typeCode: string, duration: number, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionMaterialEventSummaryFragment = { __typename?: 'ProductionMaterialEventDocument', id: string, name: string, productionMaterialEventId: string, status: Types.ProductionMaterialEventStatus, tenantId: string, createdBy: string, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, updatedBy: string };

export type ProductionMaterialEventDetailsFragment = { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> };

export type ProductionMaterialEventDetailFragmentFragment = { __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string };

export type ProductionMaterialEventDetailSummaryFragment = { __typename?: 'ProductionMaterialEventDetailDocument', id: string, productionMaterialEventDetailId: string, productionMaterialEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, materialItemId: string, materialItemDescription: string, materialName: string, materialErpCode: string, multiple: number, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export type ProductionTaskEventSummaryFragment = { __typename?: 'ProductionTaskEventDocument', id: string, tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export type ProductionTaskEventDetailsFragment = { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null }> };

export type ProductionTaskEventDetailFragmentFragment = { __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null };

export type ProductionTaskEventDetailSummaryFragment = { __typename?: 'ProductionTaskEventDetailDocument', id: string, productionTaskEventDetailId: string, productionTaskEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, multiple: number, sequence: number, materialItemId?: string | null, materialItemDescription?: string | null, taskEventTypeId: string, taskEventTypeName: string, unitsPerHour?: number | null, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export type ProductionSpaceEventSummaryFragment = { __typename?: 'ProductionSpaceEventDocument', id: string, tenantId: string, productionSpaceEventId: string, name: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionSpaceEventStatus, updatedAt: Types.TDateISO, updatedBy: string };

export type ProductionSpaceEventDetailsFragment = { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> };

export type ProductionSpaceEventDetailFragmentFragment = { __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string };

export type ProductionSpaceEventDetailSummaryFragment = { __typename?: 'ProductionSpaceEventDetailDocument', id: string, productionSpaceEventDetailId: string, productionSpaceEventId: string, tenantId: string, description: string, triggerId: string, triggerName: string, productionSpaceCategoryId: string, categoryCode: string, productionSpaceTypeId: string, typeCode: string, duration: number, status: string, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export const ProductionMaterialEventSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionMaterialEventSummary on ProductionMaterialEventDocument {
  id
  name
  productionMaterialEventId
  status
  tenantId
  createdBy
  createdAt
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionMaterialEventSummary"});
export const ProductionMaterialEventDetailFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}
    `, {"fragmentName":"ProductionMaterialEventDetailFragment"});
export const ProductionMaterialEventDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
    fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`, {"fragmentName":"ProductionMaterialEventDetails"});
export const ProductionMaterialEventDetailSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionMaterialEventDetailSummary on ProductionMaterialEventDetailDocument {
  id
  productionMaterialEventDetailId
  productionMaterialEventId
  tenantId
  description
  triggerId
  triggerName
  materialItemId
  materialItemDescription
  materialName
  materialErpCode
  multiple
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionMaterialEventDetailSummary"});
export const ProductionTaskEventSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionTaskEventSummary on ProductionTaskEventDocument {
  id
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionTaskEventSummary"});
export const ProductionTaskEventDetailFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}
    `, {"fragmentName":"ProductionTaskEventDetailFragment"});
export const ProductionTaskEventDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
    fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`, {"fragmentName":"ProductionTaskEventDetails"});
export const ProductionTaskEventDetailSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionTaskEventDetailSummary on ProductionTaskEventDetailDocument {
  id
  productionTaskEventDetailId
  productionTaskEventId
  tenantId
  description
  triggerId
  triggerName
  multiple
  sequence
  materialItemId
  materialItemDescription
  taskEventTypeId
  taskEventTypeName
  unitsPerHour
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionTaskEventDetailSummary"});
export const ProductionSpaceEventSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceEventSummary on ProductionSpaceEventDocument {
  id
  tenantId
  productionSpaceEventId
  name
  createdBy
  createdAt
  status
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionSpaceEventSummary"});
export const ProductionSpaceEventDetailFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}
    `, {"fragmentName":"ProductionSpaceEventDetailFragment"});
export const ProductionSpaceEventDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
    fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`, {"fragmentName":"ProductionSpaceEventDetails"});
export const ProductionSpaceEventDetailSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceEventDetailSummary on ProductionSpaceEventDetailDocument {
  id
  productionSpaceEventDetailId
  productionSpaceEventId
  tenantId
  description
  triggerId
  triggerName
  productionSpaceCategoryId
  categoryCode
  productionSpaceTypeId
  typeCode
  duration
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionSpaceEventDetailSummary"});
export const GetProductionMaterialEventsDocument = new TypedDocumentString(`
    query GetProductionMaterialEvents($where: ProductionMaterialEventDocumentFilterInput, $order: [ProductionMaterialEventDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionMaterialEvents(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ProductionMaterialEventSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionMaterialEventSummary on ProductionMaterialEventDocument {
  id
  name
  productionMaterialEventId
  status
  tenantId
  createdBy
  createdAt
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMaterialEventGroupsDocument = new TypedDocumentString(`
    query GetMaterialEventGroups($groupBy: MaterialEventGroupField!, $search: String) {
  materialEventGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetSpaceEventGroupsDocument = new TypedDocumentString(`
    query GetSpaceEventGroups($groupBy: SpaceEventGroupField!, $search: String) {
  spaceEventGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetTaskEventGroupsDocument = new TypedDocumentString(`
    query GetTaskEventGroups($groupBy: TaskEventGroupField!, $search: String) {
  taskEventGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetProductionMaterialEventDocument = new TypedDocumentString(`
    query GetProductionMaterialEvent($id: String!) {
  productionMaterialEvent(productionMaterialEventId: $id) {
    ...ProductionMaterialEventDetails
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const GetProductionMaterialEventDetailsDocument = new TypedDocumentString(`
    query GetProductionMaterialEventDetails($id: String!, $first: Int, $after: String) {
  productionMaterialEventDetails(
    productionMaterialEventId: $id
    first: $first
    after: $after
  ) {
    totalCount
    nodes {
      ...ProductionMaterialEventDetailSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionMaterialEventDetailSummary on ProductionMaterialEventDetailDocument {
  id
  productionMaterialEventDetailId
  productionMaterialEventId
  tenantId
  description
  triggerId
  triggerName
  materialItemId
  materialItemDescription
  materialName
  materialErpCode
  multiple
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionMaterialEventDetailsByEventsDocument = new TypedDocumentString(`
    query GetProductionMaterialEventDetailsByEvents($where: ProductionMaterialEventDetailDocumentFilterInput, $order: [ProductionMaterialEventDetailDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionMaterialEventDetails(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...ProductionMaterialEventDetailSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionMaterialEventDetailSummary on ProductionMaterialEventDetailDocument {
  id
  productionMaterialEventDetailId
  productionMaterialEventId
  tenantId
  description
  triggerId
  triggerName
  materialItemId
  materialItemDescription
  materialName
  materialErpCode
  multiple
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionTaskEventsDocument = new TypedDocumentString(`
    query GetProductionTaskEvents($where: ProductionTaskEventDocumentFilterInput, $order: [ProductionTaskEventDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionTaskEvents(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ProductionTaskEventSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionTaskEventSummary on ProductionTaskEventDocument {
  id
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTaskEventCostsDocument = new TypedDocumentString(`
    query GetTaskEventCosts($where: ProductionTaskEventDocumentFilterInput, $first: Int) {
  productionTaskEvents(where: $where, first: $first) {
    nodes {
      id
      productionTaskEventId
      costPerEvent
      costEffectiveFrom
      costEffectiveTo
    }
  }
}
    `);
export const GetProductionTaskEventDocument = new TypedDocumentString(`
    query GetProductionTaskEvent($id: String!) {
  productionTaskEvent(productionTaskEventId: $id) {
    ...ProductionTaskEventDetails
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const GetProductionTaskEventDetailsDocument = new TypedDocumentString(`
    query GetProductionTaskEventDetails($id: String!, $first: Int, $after: String) {
  productionTaskEventDetails(
    productionTaskEventId: $id
    first: $first
    after: $after
  ) {
    totalCount
    nodes {
      ...ProductionTaskEventDetailSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionTaskEventDetailSummary on ProductionTaskEventDetailDocument {
  id
  productionTaskEventDetailId
  productionTaskEventId
  tenantId
  description
  triggerId
  triggerName
  multiple
  sequence
  materialItemId
  materialItemDescription
  taskEventTypeId
  taskEventTypeName
  unitsPerHour
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionSpaceEventsDocument = new TypedDocumentString(`
    query GetProductionSpaceEvents($where: ProductionSpaceEventDocumentFilterInput, $order: [ProductionSpaceEventDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionSpaceEvents(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ProductionSpaceEventSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionSpaceEventSummary on ProductionSpaceEventDocument {
  id
  tenantId
  productionSpaceEventId
  name
  createdBy
  createdAt
  status
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionSpaceEventDocument = new TypedDocumentString(`
    query GetProductionSpaceEvent($id: String!) {
  productionSpaceEvent(productionSpaceEventId: $id) {
    ...ProductionSpaceEventDetails
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const GetProductionSpaceEventDetailsDocument = new TypedDocumentString(`
    query GetProductionSpaceEventDetails($id: String!, $first: Int, $after: String) {
  productionSpaceEventDetails(
    productionSpaceEventId: $id
    first: $first
    after: $after
  ) {
    totalCount
    nodes {
      ...ProductionSpaceEventDetailSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionSpaceEventDetailSummary on ProductionSpaceEventDetailDocument {
  id
  productionSpaceEventDetailId
  productionSpaceEventId
  tenantId
  description
  triggerId
  triggerName
  productionSpaceCategoryId
  categoryCode
  productionSpaceTypeId
  typeCode
  duration
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionMaterialEvents: build.query<GetProductionMaterialEventsQuery, GetProductionMaterialEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionMaterialEventsDocument, variables })
    }),
    GetMaterialEventGroups: build.query<GetMaterialEventGroupsQuery, GetMaterialEventGroupsQueryVariables>({
      query: (variables) => ({ document: GetMaterialEventGroupsDocument, variables })
    }),
    GetSpaceEventGroups: build.query<GetSpaceEventGroupsQuery, GetSpaceEventGroupsQueryVariables>({
      query: (variables) => ({ document: GetSpaceEventGroupsDocument, variables })
    }),
    GetTaskEventGroups: build.query<GetTaskEventGroupsQuery, GetTaskEventGroupsQueryVariables>({
      query: (variables) => ({ document: GetTaskEventGroupsDocument, variables })
    }),
    GetProductionMaterialEvent: build.query<GetProductionMaterialEventQuery, GetProductionMaterialEventQueryVariables>({
      query: (variables) => ({ document: GetProductionMaterialEventDocument, variables })
    }),
    GetProductionMaterialEventDetails: build.query<GetProductionMaterialEventDetailsQuery, GetProductionMaterialEventDetailsQueryVariables>({
      query: (variables) => ({ document: GetProductionMaterialEventDetailsDocument, variables })
    }),
    GetProductionMaterialEventDetailsByEvents: build.query<GetProductionMaterialEventDetailsByEventsQuery, GetProductionMaterialEventDetailsByEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionMaterialEventDetailsByEventsDocument, variables })
    }),
    GetProductionTaskEvents: build.query<GetProductionTaskEventsQuery, GetProductionTaskEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionTaskEventsDocument, variables })
    }),
    GetTaskEventCosts: build.query<GetTaskEventCostsQuery, GetTaskEventCostsQueryVariables | void>({
      query: (variables) => ({ document: GetTaskEventCostsDocument, variables })
    }),
    GetProductionTaskEvent: build.query<GetProductionTaskEventQuery, GetProductionTaskEventQueryVariables>({
      query: (variables) => ({ document: GetProductionTaskEventDocument, variables })
    }),
    GetProductionTaskEventDetails: build.query<GetProductionTaskEventDetailsQuery, GetProductionTaskEventDetailsQueryVariables>({
      query: (variables) => ({ document: GetProductionTaskEventDetailsDocument, variables })
    }),
    GetProductionSpaceEvents: build.query<GetProductionSpaceEventsQuery, GetProductionSpaceEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionSpaceEventsDocument, variables })
    }),
    GetProductionSpaceEvent: build.query<GetProductionSpaceEventQuery, GetProductionSpaceEventQueryVariables>({
      query: (variables) => ({ document: GetProductionSpaceEventDocument, variables })
    }),
    GetProductionSpaceEventDetails: build.query<GetProductionSpaceEventDetailsQuery, GetProductionSpaceEventDetailsQueryVariables>({
      query: (variables) => ({ document: GetProductionSpaceEventDetailsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionMaterialEventsQuery, useLazyGetProductionMaterialEventsQuery, useGetMaterialEventGroupsQuery, useLazyGetMaterialEventGroupsQuery, useGetSpaceEventGroupsQuery, useLazyGetSpaceEventGroupsQuery, useGetTaskEventGroupsQuery, useLazyGetTaskEventGroupsQuery, useGetProductionMaterialEventQuery, useLazyGetProductionMaterialEventQuery, useGetProductionMaterialEventDetailsQuery, useLazyGetProductionMaterialEventDetailsQuery, useGetProductionMaterialEventDetailsByEventsQuery, useLazyGetProductionMaterialEventDetailsByEventsQuery, useGetProductionTaskEventsQuery, useLazyGetProductionTaskEventsQuery, useGetTaskEventCostsQuery, useLazyGetTaskEventCostsQuery, useGetProductionTaskEventQuery, useLazyGetProductionTaskEventQuery, useGetProductionTaskEventDetailsQuery, useLazyGetProductionTaskEventDetailsQuery, useGetProductionSpaceEventsQuery, useLazyGetProductionSpaceEventsQuery, useGetProductionSpaceEventQuery, useLazyGetProductionSpaceEventQuery, useGetProductionSpaceEventDetailsQuery, useLazyGetProductionSpaceEventDetailsQuery } = injectedRtkApi;
